import type { RouteRecordRaw } from 'vue-router';

import Icons from '@/constants/Icons';
import RouteNames from '@/constants/RouteNames';
import type { AppRouteRecord } from '@/types/core';

export const projectListRoute: AppRouteRecord = {
  component: () => import('@/views/project/ProjectList.vue'),
  meta: {
    icon: Icons.Project,
  },
  name: RouteNames.Project.List,
  path: '',
};

export const projectRoutes: RouteRecordRaw = {
  children: [
    //
    projectListRoute,
  ],
  path: '/project',
};
